"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// MARK: Mobx
var mobx_1 = require("mobx");
var _1 = require(".");
var InfinityScrollShelf = /** @class */ (function () {
    function InfinityScrollShelf(getItems, options) {
        var _this = this;
        this._itemsPerPage = 20;
        this.loader = new _1.LoaderShelf();
        this.initialLoader = new _1.InitialLoaderShelf();
        this.fetchData = function (newPage) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var hasToReplace, possibleItems_1, newPageValue_1, e_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.loader.isLoading) {
                            return [2 /*return*/];
                        }
                        hasToReplace = false;
                        if (!newPage || newPage < 0) {
                            newPage = 0;
                            hasToReplace = true;
                            this.hasNextPage = true;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.loader.start();
                        return [4 /*yield*/, this._getItems(newPage)];
                    case 2:
                        possibleItems_1 = _a.sent();
                        if (possibleItems_1.length > 0) {
                            newPageValue_1 = newPage;
                            mobx_1.runInAction(function () {
                                _this.page = newPageValue_1;
                                _this.hasNextPage = (possibleItems_1.length === _this.itemsPerPage);
                            });
                        }
                        else {
                            this.hasNextPage = false;
                        }
                        this.appendItems(possibleItems_1, hasToReplace);
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        mobx_1.runInAction(function () {
                            if (_this.onError) {
                                _this.onError(e_1);
                            }
                            _this.fetchError = e_1;
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        this.initialLoader.done();
                        this.loader.end();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        this.applyFilter = function (filter) {
            _this.appendItems(_this.listItems.filter(filter), true);
        };
        this.appendItems = function (newItems, replace) {
            if (replace === void 0) { replace = false; }
            if (replace) {
                _this._items = newItems;
            }
            else {
                _this._items = tslib_1.__spreadArray(tslib_1.__spreadArray([], _this._items), newItems);
            }
        };
        this.prependItems = function (newItems, replace) {
            if (replace === void 0) { replace = false; }
            if (replace) {
                _this._items = newItems;
            }
            else {
                _this._items = tslib_1.__spreadArray(tslib_1.__spreadArray([], newItems), _this._items);
            }
        };
        this.replaceItem = function (itemId, newValue) {
            if (_this._items.length <= 0) {
                return;
            }
            var foundIndex = 0;
            var foundItem = _this._items.find(function (item, index) {
                if (item.id === itemId) {
                    foundIndex = index;
                    return true;
                }
                return false;
            });
            if (foundItem) {
                var leftList = _this._items.filter(function (_, i) { return i < foundIndex; });
                var rightList = _this._items.filter(function (_, i) { return i > foundIndex; });
                _this._items = tslib_1.__spreadArray(tslib_1.__spreadArray(tslib_1.__spreadArray([], leftList), [newValue]), rightList);
            }
        };
        this.nextPage = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.hasNextPage) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fetchData(this.page + 1)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        this.previousPage = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                throw new Error("Previous Page don't exist on InfinityScrollShelf");
            });
        }); };
        this.refreshItems = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchData()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.clear = function () {
            _this.fetchError = null;
            _this._items = [];
            _this.page = 0;
        };
        this.page = 0;
        this.hasNextPage = true;
        this.fetchError = null;
        this._items = [];
        this._getItems = getItems;
        mobx_1.makeAutoObservable(this);
        if (options) {
            if (options.itemsPerPage) {
                this._itemsPerPage = options.itemsPerPage;
            }
            this.onError = options.onError;
        }
        this.fetchData();
    }
    Object.defineProperty(InfinityScrollShelf.prototype, "itemsPerPage", {
        get: function () {
            return this._itemsPerPage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InfinityScrollShelf.prototype, "itemPerPage", {
        /**
         * @deprecated use items per page
         */
        get: function () {
            return this._itemsPerPage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InfinityScrollShelf.prototype, "listItems", {
        get: function () {
            return this._items.slice();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InfinityScrollShelf.prototype, "isLoading", {
        get: function () {
            return this.loader.isLoading;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InfinityScrollShelf.prototype, "listHasNextPage", {
        get: function () {
            return this.hasNextPage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InfinityScrollShelf.prototype, "isEmpty", {
        get: function () {
            return this._items.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InfinityScrollShelf.prototype, "didInitialLoading", {
        get: function () {
            return this.initialLoader.isLoading;
        },
        enumerable: false,
        configurable: true
    });
    return InfinityScrollShelf;
}());
exports.default = InfinityScrollShelf;
